import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import banner from "../../../assets/images/banner/mtm.jpg";
import { BiChevronsRight } from "react-icons/bi";
import img from "../../../assets/images/MedicationTheraphy/EMS__medication_therapy_management.webp";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";


const MTheraphy = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <Container>
      <TopServiceBanner title="MTM" banner={banner} />
      <Inner>
        <SubTitle>
          Medication Therapy Management (MTM) helps improve patients medication
          use so they can better manage their chronic conditions (e.g.,
          diabetes, hypertension, asthma) and improve their overall health.
          <br />
          <br />
          With this program, our pharmacists will ensure you are getting the
          most benefit from your medications. In addition, our pharmacists can
          help you better manage your medications and health conditions, so you
          can live a healthier life.
        </SubTitle>
        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Can you Benefit from Medication Therapy Management?
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  Do you take several medications for several different health
                  conditions?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Are you finding it difficult to manage your health and your
                  medications?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Are you having any side effects from your medications?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Do you have any questions about your medications?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Do you want to know how best to take your medications to get the most from your medications?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Do you take medications that require close monitoring such as medication levels?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Have you been hospitalized recently?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Would you like to know if you are up-to-date on the recommended vaccines?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Would you like to have a complete list of the medications you take for your personal use?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Do you have any concerns about medication costs?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Would you like to receive education on diet and exercise?
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img} alt="ALF" />
            </MiddleInnerRight>
          </MiddleInner>
          <MiddleSubTitle>
          If you answered yes to any of these questions, you may benefit from medication therapy management.
          <br /><br />
            We offer quick, efficient and accurate solutions catering patient's
            wide array of requirements. Our commitment to partnership and care
            for patients, along with our dedicated and professional staff allows
            us to continually evolve to meet the needs of each organization we
            work with.
          </MiddleSubTitle>
        </Middle>
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />

    </Container>
  );
};

export default MTheraphy;

const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 23px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Middle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding: 1rem 3rem 10rem 3rem;
`;


const MiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const MiddleInner = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 10rem;

  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }
`;

const MiddleInnerLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const MiddleInnerRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 2rem;
  }
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const Li = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const Img = styled.img`
  width: 100%;
  height: 100%;

  @media (max-width: 1180px) {
    width: 45%;
    height: 45%;
    margin-top: 1rem;
  }
`;
